import { Button, TextInput } from "@mantine/core";
import Container from "../components/common/Container";
import PageHeader from "../components/common/PageHeader";
import { useForm } from "@mantine/form";
import { validateRequired } from "../utils/validations";
import { creationNotification } from "../utils/useNotification";
import { createRole } from "../api/roleApi";
import { useAuth } from "../context/AuthContext";
import { CustomMultiSelect } from "../components/common/Inputs/MultiSelectInput";
import { useRef } from "react";
import PlusIcon from "../components/common/Icons/PlusIcon";

const NewRole = () => {
  const { skillSelectData, refetchRoleSelectData } = useAuth();
  const formRef = useRef<HTMLFormElement>(null);

  const form = useForm<any>({
    initialValues: {
      name: "",
      description: "",
      requiredSkills: [],
    },
    validate: {
      name: validateRequired,
      description: validateRequired,
    },
  });

  const handleSubmit = async (values: object) => {
    try {
      const { data, response }: any = await createRole({
        ...values,
      });

      if (data?.success) {
        creationNotification("Rol", data.success);
        refetchRoleSelectData();
        form.reset();
        return;
      }

      if (response?.data?.error) {
        alert(response?.data.error);
      }
    } catch (error) {
      console.error("Error:", error);
    }
  };

  return (
    <Container>
      <PageHeader
        pageTitle="Yeni Rol Kaydı"
        isButtoned
        buttonText="Oluştur"
        buttonIcon={<PlusIcon />}
        buttonOnClick={() => formRef.current?.requestSubmit()}
      />
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          gap: "40px",
        }}
      >
        <form
          ref={formRef}
          style={{
            width: "448px",
            display: "flex",
            flexDirection: "column",
            gap: "24px",
          }}
          onSubmit={form.onSubmit(handleSubmit)}
        >
          <TextInput
            label="Rol İsmi"
            placeholder="Rol İsmi Giriniz."
            radius={10}
            maxLength={40}
            size="md"
            {...form.getInputProps("name")}
          />
          <TextInput
            label="Rol Açıklaması"
            placeholder="Rol Açıklaması Giriniz."
            radius={10}
            maxLength={150}
            size="md"
            {...form.getInputProps("description")}
          />
          <CustomMultiSelect
            label="Yetenekler"
            placeholder="Yetenek seçiniz."
            w={"100%"}
            data={skillSelectData}
            {...form.getInputProps("requiredSkills")}
          />
        </form>
      </div>
    </Container>
  );
};

export default NewRole;
